import './input.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

const isActive = props => props.meta.active || props.input.value !== '';
const hasValue = props => !props.meta.active &&  props.input.value !== '';

const propTypes = {
	input: PropTypes.object,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	input_placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	autoFocus: PropTypes.bool,
	type: PropTypes.string,
	showLabel: PropTypes.bool
};

const defaultProps = {
	type: 'text',
	showLabel: true
};

class Input extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {touched, error} = this.props.meta;
		const className = this.props.className || '';
		return (
			<div
				className={'form-element-wrap-improve ' + className}
				onClick={ () => this.refs['input'].focus() }>

				<div className={cn(
					'form-element-field',
					this.props.showLabel && 'form-element-field--show-label'
				)}>
					<div className="form-element-field__label">
						{this.props.placeholder}
					</div>
					<div className={cn({
						'form-element-input': true,
						'is-active': isActive(this.props),
						'has-value': hasValue(this.props),
						'is-disabled': this.props.disabled
					})}>
						<div className="form-element-input__control">
							<input
								ref="input"
								placeholder={this.props.input_placeholder}
								type={this.props.type}
								autoFocus={this.props.autoFocus}
								className="control" {...this.props.input}
								onFocus={moveCaretAtEnd}
								disabled={this.props.disabled}
							/>
						</div>
						<div className="form-element-input__placeholder">
							{this.props.placeholder}
						</div>
					</div>

					{touched && error && (
						<div className="form-element-error"><span>{ error }</span></div>
					)}
				</div>
			</div>
		);
	}
}

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

const moveCaretAtEnd  = e => {
	const tempValue = e.target.value;
	e.target.value = '';
	e.target.value = tempValue;
};

export default Input;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/input.js